import React from 'react';
import { useSelector } from 'react-redux';
import { ProductPartContent } from '@yme/pdp-components/ProductPart/ProductPartContent';
import { getPDPLinks } from '@yme/selectors/common';
import { getItemImage } from '@yme/utils/common';
import { getPdpLinkByCategory, getProductURL } from '@yme/utils/product';
import { ProductPartWrapper } from '../ProductPartWrapper';
export function ProductPart({ item, labels, rootLanguage, isInAuthor, isRightToLeft, viewDetailsLabel, privacyConsentsModel, }) {
    const pdpLinks = useSelector(getPDPLinks);
    const { variants, name, slug, categories } = item;
    const { attributes, images, prices, sku } = variants[0];
    const itemImage = getItemImage(images);
    const [price] = prices;
    const pdpPath = getPdpLinkByCategory(pdpLinks, categories);
    const itemUrl = getProductURL({
        path: pdpPath,
        isInAuthor,
        slug,
    });
    return (React.createElement(ProductPartWrapper, { isRightToLeft: isRightToLeft, itemUrl: itemUrl, itemImage: itemImage },
        React.createElement(ProductPartContent, { name: name, itemImage: itemImage, sku: sku, itemUrl: itemUrl, viewDetailsLabel: viewDetailsLabel, rootLanguage: rootLanguage, isRightToLeft: isRightToLeft, price: price, labels: labels, privacyConsentsModel: privacyConsentsModel, attributes: attributes })));
}
